import styles from './PlayerContract.module.scss';
import { ContractHistoryDiff } from '@/api/models/PlayerContractHistory';
import { PlayerForSaveDto } from '@/api/models';
import dayjs from 'dayjs';

interface IProps {
  contractHistoryDiff: ContractHistoryDiff[];
  player: PlayerForSaveDto | null;
  handleCloseHistory: () => void;
}

function PlayerContractHistory({ contractHistoryDiff, player, handleCloseHistory }: IProps) {
  return (
    <>
      <div className={styles.historyNavbar}>
        <div className={styles.historyTitle}>Contract History</div>
        <div className={styles.historyCloseButton}></div>
      </div>
      <div className={styles.playerName}>{player?.fullName || ''}</div>
      <div>
        <hr />
      </div>
      <div className={styles.historyContainer}>
        {contractHistoryDiff.length == 0 && <span>No contract history to display.</span>}
        {contractHistoryDiff.map((diff, ix) => (
          <div className={styles.historyFrame} key={ix}>
            <div className={styles.flex}>
              <div className={styles.historyCardTitle}></div>
              <div className={styles.tourName}>{dayjs(diff.snapshotCreatedAt).format('MM-DD-YYYY')}</div>
              <div className={styles.historyName}>{diff.fullName}</div>
            </div>
            <div className={styles.flex}>
              <div className={styles.historyDateLabel}>Start Date:</div>
              <div className={styles.historyDate}>{dayjs(diff.startDate).format('MM/DD/YYYY')}</div>
              <div className={styles.historyDateLabel}>End Date:</div>
              <div className={styles.historyDate}>{dayjs(diff.endDate).format('MM/DD/YYYY')}</div>
            </div>
            {diff.itemsAdded.length > 0 && (
              <div className={styles.historyItemRow}>
                <div className={styles.historyItemLabel}>Items Added: {diff.itemsAdded.join(', ')}</div>
              </div>
            )}
            {diff.itemsRemoved.length > 0 && (
              <div className={styles.historyItemRow}>
                <div className={styles.historyItemLabel}>Items Removed: {diff.itemsRemoved.join(', ')}</div>
              </div>
            )}
          </div>
        ))}
        <div role="button" onClick={handleCloseHistory} className={styles.closeHistory}>
          Back
        </div>
      </div>
    </>
  );
}

export default PlayerContractHistory;
